/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingV1WorkChargeLinesCreatePathParameters,
  BillingV1WorkChargeLinesDestroyPathParameters,
  BillingV1WorkChargeLinesListParams,
  BillingV1WorkChargeLinesListPathParameters,
  BillingV1WorkChargeLinesPartialUpdatePathParameters,
  BillingV1WorkChargeLinesRetrievePathParameters,
  CursorPaginatedWorkChargeLineResponseV1,
  PatchedWorkChargeLineUpdateRequestV1Request,
  WorkChargeLineCreateRequestV1Request,
  WorkChargeLineResponseV1,
  WorkChargeResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingWorkChargeLineService {
  private readonly http = inject(HttpClient);
/**
 * Sub-resource list — returns every WorkChargeLine belonging to the parent WorkCharge, cursor-paginated. Ordered by insertion (id ASC). Admin-only.
 * @summary List all lines of a WorkCharge
 */
 billingV1WorkChargeLinesList<TData = CursorPaginatedWorkChargeLineResponseV1>(pathParams: BillingV1WorkChargeLinesListPathParameters,
    params?: BillingV1WorkChargeLinesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargeLinesList<TData = CursorPaginatedWorkChargeLineResponseV1>(pathParams: BillingV1WorkChargeLinesListPathParameters,
    params?: BillingV1WorkChargeLinesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargeLinesList<TData = CursorPaginatedWorkChargeLineResponseV1>(pathParams: BillingV1WorkChargeLinesListPathParameters,
    params?: BillingV1WorkChargeLinesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargeLinesList<TData = CursorPaginatedWorkChargeLineResponseV1>(
    { identity }: BillingV1WorkChargeLinesListPathParameters,
    params?: BillingV1WorkChargeLinesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. Appends one line to the WorkCharge identified by `identity`. Rejects with 409 `/problems/work-charge-paid` if the parent is already paid, and with 409 `/problems/work-charge-lines-full` if it already holds the most lines a charge takes (the `maxItems` of `lines` on its create). The line stores its own NET `subtotal` and `margin`; omit `unit_cost` and `unit_price` to copy the BillingItem's `cost_price` and `sale_price`. Recomputes `total_net`, `iva` and `total` server-side atomically (M-bill-6). Response wraps the parent charge (totals only — lines live in the `/lines/` sub-resource) so the front sees the new total without an extra GET.
 * @summary Append 1 line to an existing WorkCharge.
 */
 billingV1WorkChargeLinesCreate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargeLinesCreatePathParameters,
    workChargeLineCreateRequestV1Request: WorkChargeLineCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargeLinesCreate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargeLinesCreatePathParameters,
    workChargeLineCreateRequestV1Request: WorkChargeLineCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargeLinesCreate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargeLinesCreatePathParameters,
    workChargeLineCreateRequestV1Request: WorkChargeLineCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargeLinesCreate<TData = WorkChargeResponseV1>(
    { identity }: BillingV1WorkChargeLinesCreatePathParameters,
    workChargeLineCreateRequestV1Request: WorkChargeLineCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/work_charges/${identity}/lines/`,
      workChargeLineCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/work_charges/${identity}/lines/`,
      workChargeLineCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/work_charges/${identity}/lines/`,
      workChargeLineCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Sub-resource detail — returns one WorkChargeLine scoped to its parent WorkCharge. Returns 404 if the line does not belong to this charge (prevents line-identity guessing across charges). Admin-only.
 * @summary Get one line of a WorkCharge
 */
 billingV1WorkChargeLinesRetrieve<TData = WorkChargeLineResponseV1>(pathParams: BillingV1WorkChargeLinesRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargeLinesRetrieve<TData = WorkChargeLineResponseV1>(pathParams: BillingV1WorkChargeLinesRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargeLinesRetrieve<TData = WorkChargeLineResponseV1>(pathParams: BillingV1WorkChargeLinesRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargeLinesRetrieve<TData = WorkChargeLineResponseV1>(
    { identity, lineIdentity }: BillingV1WorkChargeLinesRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Editable fields: `quantity`, `unit_cost`, `unit_price`, `discount_pct`, `description`. `billing_item` is immutable — changing the item = DELETE + POST. Rejected if the parent charge is already paid. The line's `subtotal` and `margin` are rewritten from the resulting values, and the parent's `total_net`, `iva` and `total` are recomputed server-side atomically (M-bill-6).
 * @summary Partial-update one line of a WorkCharge (preserve-on-omit).
 */
 billingV1WorkChargeLinesPartialUpdate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargeLinesPartialUpdatePathParameters,
    patchedWorkChargeLineUpdateRequestV1Request?: PatchedWorkChargeLineUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargeLinesPartialUpdate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargeLinesPartialUpdatePathParameters,
    patchedWorkChargeLineUpdateRequestV1Request?: PatchedWorkChargeLineUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargeLinesPartialUpdate<TData = WorkChargeResponseV1>(pathParams: BillingV1WorkChargeLinesPartialUpdatePathParameters,
    patchedWorkChargeLineUpdateRequestV1Request?: PatchedWorkChargeLineUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargeLinesPartialUpdate<TData = WorkChargeResponseV1>(
    { identity, lineIdentity }: BillingV1WorkChargeLinesPartialUpdatePathParameters,
    patchedWorkChargeLineUpdateRequestV1Request?: PatchedWorkChargeLineUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,
      patchedWorkChargeLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,
      patchedWorkChargeLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,
      patchedWorkChargeLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Removes the line identified by `line_identity` from the parent WorkCharge. Rejected if the parent is already paid. Recomputes `total_net`, `iva` and `total` server-side atomically (M-bill-6). Response is 204 with an empty body, so refresh the charge with a GET to read the new amounts.
 * @summary Remove one line from a WorkCharge.
 */
 billingV1WorkChargeLinesDestroy<TData = void>(pathParams: BillingV1WorkChargeLinesDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1WorkChargeLinesDestroy<TData = void>(pathParams: BillingV1WorkChargeLinesDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1WorkChargeLinesDestroy<TData = void>(pathParams: BillingV1WorkChargeLinesDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1WorkChargeLinesDestroy<TData = void>(
    { identity, lineIdentity }: BillingV1WorkChargeLinesDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/work_charges/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1WorkChargeLinesListClientResult = NonNullable<CursorPaginatedWorkChargeLineResponseV1>
export type BillingV1WorkChargeLinesCreateClientResult = NonNullable<WorkChargeResponseV1>
export type BillingV1WorkChargeLinesRetrieveClientResult = NonNullable<WorkChargeLineResponseV1>
export type BillingV1WorkChargeLinesPartialUpdateClientResult = NonNullable<WorkChargeResponseV1>
export type BillingV1WorkChargeLinesDestroyClientResult = NonNullable<void>
